import React from 'react';
import classNames from 'classnames';

import './image.scss';

export enum ImageType {
  homeLogos,
  homeRocket,
  startKleermaker,
  startRocket,
  startExample,
  startArrow,
  rating,
  fittingSuit,
  fittingSuits,
  fittingKleermaker,
  launchingKleermaker,
  launchingRocket,
  launchingSmoke,
  resultsHeader,
  resultsTitle,
  logoSportamundi,
  logoNYSI,
  logoHAN,
  logoSportVlaanderen,
  logoUgentNL,
  logoUgentEN
}

interface ImageProps {
  type?: ImageType;
  imgSrc: string;
  alt?: string;
  text?: string;

  extraClasses?: string;
  imgUrl?: string;
  children?: any;
}

const defaultProps: ImageProps = {
  imgSrc: '',
  extraClasses: '',
  imgUrl: ''
};

const Image: React.SFC<ImageProps> = props => (
  <div
    className={classNames(
      `c-image${props.extraClasses !== '' ? ' ' + props.extraClasses : ''}`,
      {
        'c-image--home-logos': props.type === ImageType.homeLogos,
        'c-image--home-rocket': props.type === ImageType.homeRocket,
        'c-image--start-kleermaker': props.type === ImageType.startKleermaker,
        'c-image--start-rocket': props.type === ImageType.startRocket,
        'c-image--start-example': props.type === ImageType.startExample,
        'c-image--start-arrow': props.type === ImageType.startArrow,
        'c-image--rating': props.type === ImageType.rating,
        'c-image--fitting-kleermaker':
          props.type === ImageType.fittingKleermaker,
        'c-image--fitting-suit': props.type === ImageType.fittingSuit,
        'c-image--fitting-suits': props.type === ImageType.fittingSuits,
        'c-image--launching-kleermaker':
          props.type === ImageType.launchingKleermaker,
        'c-image--launching-rocket': props.type === ImageType.launchingRocket,
        'c-image--launching-smoke': props.type === ImageType.launchingSmoke,
        'c-image--results-header': props.type === ImageType.resultsHeader,
        'c-image--results-title': props.type === ImageType.resultsTitle,
        'c-image--logo-sportamundi': props.type === ImageType.logoSportamundi,
        'c-image--logo-nysi': props.type === ImageType.logoNYSI,
        'c-image--logo-han': props.type === ImageType.logoHAN,
        'c-image--logo-sport-vlaanderen':
          props.type === ImageType.logoSportVlaanderen,
        'c-image--logo-ugent-nl': props.type === ImageType.logoUgentNL,
        'c-image--logo-ugent-en': props.type === ImageType.logoUgentEN
      }
    )}
  >
    {props.imgUrl ? (
      <a href={props.imgUrl} target="_blank">
        <img
          src={props.imgSrc}
          className={classNames('c-image__src')}
          alt={props.alt}
        />
      </a>
    ) : (
      <img
        src={props.imgSrc}
        className={classNames('c-image__src')}
        alt={props.alt}
      />
    )}

    {props.children && props.children}

    {props.text && (
      <span
        className={classNames('c-image__label', {
          'c-image__rating-label': props.type === ImageType.rating
        })}
      >
        {props.text}
      </span>
    )}
  </div>
);

Image.defaultProps = defaultProps;

export default Image;



// WEBPACK FOOTER //
// ./src/components/image/image.tsx